import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PipesModule } from "../pipes/pipes.module";

import { FormsModule } from "@angular/forms";

import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzDropdownMenuComponent } from "ng-zorro-antd/dropdown";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzIconModule } from "ng-zorro-antd/icon";

import { ChangeLanguageComponent } from "./change-language/change-language.component";
import { AppUserLoginComponent } from "./app-user-login/app-user-login.component";

@NgModule({
  declarations: [ChangeLanguageComponent, AppUserLoginComponent],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    NzDropDownModule,
    NzGridModule,
    NzIconModule,
  ],
  exports: [ChangeLanguageComponent],
})
export class ComponentsModule {}
